import _ from "lodash";
import {ARCNFK} from "../../../const/form-field.const";
import {isArray} from "@dladio/utils";
import {useDispatch} from "react-redux";
import {ARCN_STORE_PATH} from "../../../const/local-store.const";
import {ARCN_FORM_STORE_KEYS} from "../../../const/form-store.const";
import {useForm, useLocalStore} from "@dladio/hooks";
import {TupleCard, TupleCardLine} from "@dladio/core-ui";
import {FontIcon, Text, TextField} from "@fluentui/react";
import {getFormValue, setLocalStoreValue} from "../actions/actions";

const Summary = () => {
    const {setStore} = useLocalStore(ARCN_STORE_PATH.FREIGHT_EDIT_PANEL)
    const {setStore: setDownPaymentStore} = useLocalStore(ARCN_STORE_PATH.DOWN_PAYMENT)
    const {model} = useLocalStore(ARCN_FORM_STORE_KEYS.CURRENCY)
    const {form: mainForm} = useForm(ARCN_FORM_STORE_KEYS.CREDIT_NOTE)
    const {form: freightForm} = useForm(ARCN_FORM_STORE_KEYS.FREIGHT_FORM)
    const {form: downPaymentForm} = useForm(ARCN_FORM_STORE_KEYS.DOWN_PAYMENT)
    const {form} = useForm(ARCN_FORM_STORE_KEYS.TABLE_LINE_FORM)
    const dispatch: any = useDispatch()
    const {
        form: purchOrderForm,
        formController: formControllerPo
    } = useForm(ARCN_FORM_STORE_KEYS.CREDIT_NOTE)

    const totalBeforeDiscount: any = isArray(form) ? form?.reduce((prevValue: any, currentValue: any) => (
        prevValue + ((+currentValue?.Quantity * currentValue?.Price) - (currentValue?.DiscountAmount ? currentValue?.DiscountAmount : 0)
        )
    ), 0) : 0

    const freight: any = isArray(freightForm) ? freightForm.reduce((prevValue: any, currentValue: any) => (
        prevValue + (currentValue?.NetAmount ? +(currentValue?.NetAmount) : 0)
    ), 0) : 0

    const freightTax = isArray(freightForm) ? freightForm.reduce((prevValue: any, currentValue: any) => (
        prevValue + (currentValue?.TotalTaxAmount ? currentValue?.TotalTaxAmount : 0)
    ), 0) : 0

    const totalDownPayment = isArray(downPaymentForm) ? downPaymentForm.reduce((prevValue: any, currentValue: any) => (
        prevValue + (currentValue?.AmountToDraw ? +(currentValue?.AmountToDraw) : 0)
    ), 0) : 0

    const taxFromDownPayment: any = isArray(downPaymentForm) ? downPaymentForm?.reduce((prevValue: any, currentValue: any) => (prevValue + (
            currentValue?.Tax ? +currentValue?.Tax : 0)
    ), 0) : 0

    const tax: any = isArray(form) ? form?.reduce((prevValue: any, currentValue: any) => (prevValue + (
            currentValue?.TaxAmount ? +currentValue?.TaxAmount : 0)
    ), 0) - taxFromDownPayment + freightTax : 0

    const orderDiscount: any = (+(totalBeforeDiscount ?? 0) * (+(_.get(purchOrderForm, ARCNFK.ORDER_DISCOUNT) ?? 0) / 100))
        .toFixed(2)

    const total: any = isArray(form) ? form?.reduce((prevValue: any, currentValue: any) => (
        prevValue + (currentValue?.LineTotal ? +currentValue?.LineTotal : 0)
    ), 0) + tax + freight - orderDiscount - totalDownPayment : 0

    const appliedAmount: any = _.get(mainForm, 'AppliedAmount', 0.00)
    const openBalance: any = total - appliedAmount
    const onClickFreightHandler = () => {
        setStore('is-open', true)
    }

    const onClickDownPaymentHandler = () => {
        let model = dispatch(getFormValue(ARCN_FORM_STORE_KEYS.DOWN_PAYMENT))
        dispatch(setLocalStoreValue(ARCN_STORE_PATH.SELECTED_DOWN_PAYMENT, '', _.isArray(model) ? model : []))
        setDownPaymentStore('is-open', true)
    }

    const discountTupleLineMarkup: any = (
        <div className={'grid grid-cols-12 gx-0 border-b'}>
            <div className={'col-span-1'}>
                <Text
                    className={'font-semibold'}
                    variant={'small'}>
                    Discount
                </Text>
            </div>
            <div className={'col-span-3'}>
                <div className={'grid grid-cols-5'}>
                    <div className={'col-span-4 ml-3'}>
                        <TextField name={ARCNFK.ORDER_DISCOUNT} value={_.get(purchOrderForm, ARCNFK.ORDER_DISCOUNT)}
                                   onChange={formControllerPo}/>
                    </div>
                    <div className={'flex justify-center items-center align-middle'}>
                        %
                    </div>
                </div>
            </div>

            <div onClick={onClickFreightHandler}
                 className={'flex  col-span-6 flex-row gap-2'}
            >
                <Text
                    className={''}
                    variant={'small'}>
                    {`${model ?? ''} ${isNaN(orderDiscount) ? `0.00` : orderDiscount}`}
                </Text>
            </div>
        </div>
    )

    const freightTupleLineMarkup = (
        <div className={'grid grid-cols-12 gx-0  border-b'}>
            <div className={'col-span-4'}>
                <Text
                    className={'font-semibold'}
                    variant={'small'}>
                    Freight
                </Text>
            </div>
            <div onClick={onClickFreightHandler}
                 className={'flex col-span-6 flex-row gap-2'}
            >
                <Text
                    className={''}
                    variant={'small'}>
                    {`${model ?? ''} ${freight.toFixed(2) ?? 0.00}`}
                </Text>
                <FontIcon
                    onClick={() => onClickFreightHandler()} className={''}
                    style={{fontSize: 10, cursor: 'pointer'}}
                    iconName="EditSolid12"
                />
            </div>
        </div>
    )

    const downPaymentTupleLineMarkup = (
        <div className={'grid grid-cols-12 gx-0  border-b'}>
            <div className={'col-span-4'}>
                <Text
                    className={'font-semibold'}
                    variant={'small'}>
                    Down payment
                </Text>
            </div>
            <div onClick={onClickDownPaymentHandler}
                 className={'flex col-span-6 flex-row gap-2'}
            >
                <Text
                    className={''}
                    variant={'small'}>
                    {`${model ?? ''} ${totalDownPayment.toFixed(2) ?? 0.00}`}
                </Text>
                <FontIcon
                    onClick={() => onClickFreightHandler()} className={''}
                    style={{fontSize: 10, cursor: 'pointer'}}
                    iconName="EditSolid12"
                />
            </div>
        </div>
    )

    return (

        <TupleCard title='Summary'>
            <TupleCardLine title="Total Item"
                           value={`${isArray(form) ? form?.length : 0}`}/>
            <TupleCardLine title="Total Before Discount"
                           value={`${model ?? ''} ${(totalBeforeDiscount ? totalBeforeDiscount : 0.00)?.toFixed(2)}`}/>
            {discountTupleLineMarkup}
            {downPaymentTupleLineMarkup}
            {freightTupleLineMarkup}
            <TupleCardLine title="Total Tax" value={`${model ?? ''} ${tax?.toFixed(2)}`}/>
            <TupleCardLine title="Total" value={`${model ?? ''} ${total?.toFixed(2)}`}/>
            <TupleCardLine title="Applied Amount" value={`${model ?? ''} ${appliedAmount?.toFixed(2)}`}/>
            <TupleCardLine title="Open Balance" value={`${model ?? ''} ${openBalance?.toFixed(2)}`}/>
        </TupleCard>
    )
}

export default Summary